<template>
  <div class="info-card">
    <div class="info-value">
      <b>{{ info.flowAreaMu || 0 }}亩</b>
    </div>
    <hr class="divider" />
    <a
      href="javascript:void(0);"
      class="detail-link"
      @click="handleDetailClick"
    >
      <svg
        class="link-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
      </svg>
      查看详情
    </a>
  </div>
</template>

<script>
import { centroid as centroidT } from "@turf/turf";
export default {
  props: ["info", "curTab"],
  methods: {
    /**
     * 处理查看详情
     */
    handleDetailClick() {
      let xmbh = this.info.xmbh;
      let centerPoint = this.info.centerPoint;
      let shape = this.info.shape;
      if (shape) {
        const polygonGeoJSON = {
          type: "Polygon",
          coordinates: shape,
        };

        // 计算质心
        const centroid = centroidT(polygonGeoJSON);
        const center = centroid.geometry.coordinates;
             console.log(this.info,shape, "shape------");
        console.log([center[1], center[0]]);
        centerPoint=center[1]+","+center[0]
      }

      console.log(
        "----------跳转xmbh,centerPoint,curTab------",
        xmbh,
        centerPoint,
        this.curTab
      );
      this.$router.push({
        name: "projectDetail",
        query: { c: xmbh, centerPoint, curTab: this.curTab },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.info-card {
  font-family: Arial, sans-serif;
  max-width: 250px;
}

.info-value {
  line-height: 1.5;
}

.divider {
  margin: 8px 0 4px 0;
  // border: none;
  // border-top: 1px solid #eee;
}

.detail-link {
  display: inline-flex;
  align-items: center;
  color: rgb(0, 0, 225);
  text-decoration: none;
}

.link-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
</style>
